export const LocationValues = {
  All: $localize`All`,
  Facility: $localize`Facility`,
  Other: $localize`Other`,
};

export const VehicleOptions = {
  MINIVAN: $localize`Minivan`,
  CARGO_VAN: $localize`Cargo Van`,
  LARGE_CARGO_VAN: $localize`Cargo Van Large`,
  TRUCK: $localize`Truck Small`,
  UPS: $localize`UPS Vehicle`,
};

export enum TotalRouteAdminControls {
  ROUTE = 'route_id',
  LBT = 'leavebldg_time',
  OPTIMIZE = 'is_optimizeroute',
  VEHICLE = 'vehicle',
  LOCATION_START_END = 'startend_location',
  ADDRESS_START_END = 'startend_address',
  BREAK = 'break_exist',
  BREAK_START = 'break_start',
  BREAK_END = 'break_end',
  DURATION = 'break_duration',
  DEL_WAIT_TIME = 'waittime_del',
  PU_WAIT_TIME = 'waittime_pickup',
  LAT_START_END = 'startend_latitude',
  LONG_START_END = 'startend_longitude',
}
